var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": `${_vm.openedTask ? '编辑' : '新增'}任务`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "formItem"
  }, [_c('div', {
    staticClass: "formItem-left"
  }, [_c('FormItem', {
    attrs: {
      "label": "任务标题",
      "prop": "title"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入任务标题"
    },
    model: {
      value: _vm.formItem.title,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "title", $$v);
      },
      expression: "formItem.title"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "任务内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入任务内容..."
    },
    model: {
      value: _vm.formItem.content,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "content", $$v);
      },
      expression: "formItem.content"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "任务类型",
      "prop": "type"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.formItem.type,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "type", $$v);
      },
      expression: "formItem.type"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "MonthlySalesPlan"
    }
  }, [_c('span', [_vm._v("月度销售计划")])]), _c('Radio', {
    attrs: {
      "label": "MonthlyReceivePlan"
    }
  }, [_c('span', [_vm._v("月度回款计划")])]), _c('Radio', {
    attrs: {
      "label": "SalesWeeklyReport"
    }
  }, [_c('span', [_vm._v("销售周报")])])], 1)], 1), _c('FormItem', {
    attrs: {
      "label": "主要负责人",
      "prop": "mainResponsible"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.choseMainResponsible
    },
    model: {
      value: _vm.formItem.mainResponsible,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "mainResponsible", $$v);
      },
      expression: "formItem.mainResponsible"
    }
  }, _vm._l(_vm.userList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "参与人",
      "prop": "involveMember"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.choseInvolveMemberList
    },
    model: {
      value: _vm.formItem.involveMember,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "involveMember", $$v);
      },
      expression: "formItem.involveMember"
    }
  }, _vm._l(_vm.userList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1)], 1)]), _c('div', {
    staticClass: "bottom-button"
  }, [_c('FormItem', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1), _vm.openedTask && _vm.user.superAdmin ? _c('Button', {
    attrs: {
      "type": "error",
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        _vm.delSalesModal = true;
      }
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }